"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { ProfileBadgeSize } from "./ProfileAvatar";
interface ProfileHandleProps {
  readonly handle?: string | null | undefined;
  readonly size: ProfileBadgeSize;
  readonly href?: string | undefined;
  readonly asLink?: boolean | undefined;
  readonly highlightSearchParam?: string | undefined;
}
const TEXT_SIZE_CLASSES: Record<ProfileBadgeSize, string> = {
  [ProfileBadgeSize.COMPACT]: "tw-text-sm",
  [ProfileBadgeSize.SMALL]: "tw-text-sm",
  [ProfileBadgeSize.MEDIUM]: "tw-text-md",
  [ProfileBadgeSize.LARGE]: "tw-text-md"
};
export default function ProfileHandle(t0) {
  const $ = _c(12);
  const {
    handle,
    size,
    href,
    asLink: t1,
    highlightSearchParam: t2
  } = t0;
  const asLink = t1 === undefined ? true : t1;
  const highlightSearchParam = t2 === undefined ? "user" : t2;
  const searchParams = useSearchParams();
  let t3;
  if ($[0] !== highlightSearchParam || $[1] !== searchParams) {
    t3 = (searchParams.get(highlightSearchParam) ?? "").toLowerCase();
    $[0] = highlightSearchParam;
    $[1] = searchParams;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const paramValue = t3;
  const t4 = handle ?? "";
  let t5;
  if ($[3] !== t4) {
    t5 = t4.toLowerCase();
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const amISubject = t5 === paramValue;
  const textClasses = TEXT_SIZE_CLASSES[size];
  const isLinkEnabled = !!(asLink && href && !amISubject);
  let t6;
  if ($[5] !== handle || $[6] !== href || $[7] !== isLinkEnabled) {
    t6 = isLinkEnabled ? <Link onClick={_temp} href={href} className="tw-no-underline tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-500 hover:tw-underline">{handle}</Link> : handle;
    $[5] = handle;
    $[6] = href;
    $[7] = isLinkEnabled;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const content = t6;
  const t7 = `${textClasses} tw-mb-0 tw-font-semibold tw-leading-none tw-text-iron-50`;
  let t8;
  if ($[9] !== content || $[10] !== t7) {
    t8 = <p className={t7}>{content}</p>;
    $[9] = content;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
function _temp(e) {
  return e.stopPropagation();
}
export type { ProfileHandleProps };